import * as React from 'react';

import './ToolTip.scss';

class ToolTip extends React.Component {
    public props: any;
    public parent: HTMLElement;
    public target: HTMLElement;

    public docEventHandler: any;

    constructor(props: any) {
        super(props);

        this.setParent = this.setParent.bind(this);
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }

    public componentDidMount() {
        this.docEventHandler = (event: any) => {
            const $tooltip: NodeListOf<HTMLElement> = document.querySelectorAll('[data-type="tooltip"]');
    
            if ( $tooltip.length > 0 ) {
                $tooltip[0].remove();
            }
        };

        document.removeEventListener('click', this.docEventHandler, false);
        document.addEventListener('click', this.docEventHandler, false);
    }

    public handleMouseOver(event: any) {
        const $target: HTMLElement = event.target;

        if ( document.querySelectorAll('[data-type="tooltip"]').length > 0 ) {
            return;
        }

        this.target = $target;
        const rect = $target.getBoundingClientRect();

        const position = this.props.position || undefined;

        const $targetWidth = $target.scrollWidth;
        const $left = rect.left;
        const $top = rect.top;
        const $height = $target.scrollHeight;

        const $tooltip = document.createElement('div');
        const $text = document.createTextNode(this.props.text);

        $tooltip.setAttribute('data-type', 'tooltip');

        if ( position ) {

            $tooltip.classList.remove('top', 'left', 'right');

            if ( position === 'right' ) {
                $tooltip.classList.add(this.props.position);
                $tooltip.style.visibility = 'hidden';
                $tooltip.style.top = $top + 'px';
                $tooltip.style.left = rect.right + 16 + 'px';

            }

            if ( position === 'left' ) {
                $tooltip.classList.add(this.props.position);
                $tooltip.style.visibility = 'hidden';
                $tooltip.style.top = $top + 'px';
                $tooltip.style.left = '';
                $tooltip.style.right = (window.innerWidth - rect.left) + 8 + 'px';

            }

            if ( position === 'top' ) {
                $tooltip.classList.add(this.props.position);
                $tooltip.style.visibility = 'hidden';
                $tooltip.style.bottom = (window.innerHeight - $top) + 8 + 'px';
                $tooltip.style.left = $left + ($targetWidth/2) + 'px';

            }


        } else {
            $tooltip.style.visibility = 'hidden';
            $tooltip.style.left = $left + ($targetWidth/2) + 'px';
            $tooltip.style.top = $top + $height + 12 + 'px';
        }


        $tooltip.appendChild($text);

        const $root = document.getElementById('root');

        if ( $root !== null ) {
            document.body.appendChild($tooltip);
            
            const $width = $tooltip.scrollWidth;
            const $tHeight = $tooltip.scrollHeight;
            
            if ( position !== 'left' && position !== 'right' ) {
                $tooltip.style.marginLeft = '-' + $width/2 + 'px';

            } else {
                $tooltip.style.marginTop = '-' + ($tHeight-$height)/2 + 'px';
            }

            $tooltip.style.visibility = 'visible';
        }
    }

    public handleMouseOut(event: any) {

        const $tooltip: NodeListOf<HTMLElement> = document.querySelectorAll('[data-type="tooltip"]');

        if ( $tooltip.length > 0 ) {
            $tooltip[0].remove();
        }
    }

    public setParent(node: any) {

        if ( !node ) {
            return;
        }

        this.parent = node;
        const $nodes = this.parent.childNodes;

        if ( $nodes.length > 0 ) {
            $nodes[0].addEventListener('mouseenter', (event: any) => {
                this.handleMouseOver(event);
            });
            $nodes[0].addEventListener('mouseleave', (event: any) => {
                this.handleMouseOut(event);
            });
        }
    }

    public render() {
        return(
            <div 
                className="tooltip-component"
                ref={this.setParent}
            >
                {this.props.children}
            </div>
        );
    }
}

export default ToolTip;


// WEBPACK FOOTER //
// ./src/Components/Tooltip/Tooltip.tsx